var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M186.301 339.893L96 249.461l-32 30.507L186.301 402 448 140.506 416 110z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }